import type { ComponentChildren } from 'preact';
import './Card.css';

interface Props {
  children: ComponentChildren;
  padded?: boolean;
  class?: string;
}

export function Card({ children, padded = true, class: klass }: Props) {
  return <section class={`hv-card${padded ? ' hv-card--padded' : ''} ${klass ?? ''}`}>{children}</section>;
}

export function CardHeader({ children }: { children: ComponentChildren }) {
  return <header class="hv-card__header">{children}</header>;
}

export function CardBody({ children }: { children: ComponentChildren }) {
  return <div class="hv-card__body">{children}</div>;
}
